import { Employee } from './employee.model';

export interface Allocation {
  id: string;
  employeeId: string;
  employeeName: string;
  roleId: string;
  roleTitle?: string;
  /** Projected from Employee.Designation / Employee.Category by the backend; read-only. */
  designationName?: string;
  categoryName?: string;
  projectId: string;
  invoiceType: InvoiceType;
  costCenterId?: string;
  costCenterName?: string;
  serviceGroupId?: string;
  serviceGroupName?: string;
  projectName: string;
  /** True when the allocated project is an in-pursuit presales deal (grid shows a badge). */
  isProjectPresales?: boolean;
  /**
   * True when the allocated row is a tracker ACTIVITY twin rather than a pursuit. Only ever
   * set alongside isProjectPresales — both are presales, this separates deal from activity.
   */
  isProjectPresalesActivity?: boolean;
  managerName: string;
  reportsToEmployeeId?: string;
  month: Month;
  year: number;
  week1Percentage: number;
  week2Percentage: number;
  week3Percentage: number;
  week4Percentage: number;
  week5Percentage: number;
  comments?: string;
  reportsToEmployee?: Employee;
}

export enum EmployeeRole {
  Dev = 1,
  QA = 2,
  ProjectManager = 3,
  BA = 4,
  DevIntern = 5,
  QAIntern = 6,
  DevOpsIntern = 7,
  SeniorProjectManager = 8,
  DataIntern = 9,
  BAIntern = 10,
}

export enum InvoiceType {
  Monthly = 1,
  ProjectMilestone = 2,
  NotAvailable = 3
}

export enum Month {
  January = 1,
  February = 2,
  March = 3,
  April = 4,
  May = 5,
  June = 6,
  July = 7,
  August = 8,
  September = 9,
  October = 10,
  November = 11,
  December = 12
}

export enum AllocationStatus {
  Planned = 1,
  Confirmed = 2
}

